// extracted by mini-css-extract-plugin
export default {"header":"H2u_fh","avatar":"ehV0EJ","avatarImg":"z9GUCT","nameEmailContainer":"lmWum9","name":"kbRTRN","email":"MG8a_y","content":"KGKuic","footer":"DZk2n9"};